import { shiftDays } from '../types';
export const getShiftDaysOptions = (t) => shiftDays.map((day) => {
    return {
        label: t(`weekdays.${day}`),
        value: day,
    };
});
